'use client'

import * as pixl from '@indxsearch/pixl'
import type { ComponentType } from 'react'
import styles from './Pixl.module.css'

type IconProps = { color?: string; size?: number | string }

type PixlProps = {
  /** Name of a @indxsearch/pixl icon, e.g. "Nuget", "Rag_search", "Cloud". */
  name?: string
  color?: string
  size?: number | string
  className?: string
}

/**
 * Renders a @indxsearch/pixl icon by name. Mirrors the PixlIcon pattern in
 * indx-docs so the same icon names work here. Icons follow the surrounding
 * font-size by default (see Pixl.module.css), which keeps inline icons aligned
 * to text and makes heading icons scale automatically.
 */
export default function Pixl({ name, color = 'currentColor', size, className }: PixlProps) {
  if (!name) return null
  const Icon = (pixl as Record<string, ComponentType<IconProps>>)[name]
  if (!Icon) return null
  const classes = `pixl-icon ${styles.icon}${className ? ` ${className}` : ''}`
  return (
    <span className={classes}>
      <Icon color={color} size={size} />
    </span>
  )
}
